import styled from 'styled-components';

export const AuthViewWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AuthViewHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const AuthViewTitle = styled.span`
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
`;

export const LogoWrapper = styled.div`
  align-self: center;
  cursor: pointer;

  img {
    width: 200px;
  }

  @media screen and (min-width: 600px) {
    img {
      width: 250px;
    }
  }

  @media screen and (min-width: 1200px) {
    img {
      width: 300px;
    }
  }
`;

export const AuthWrapper = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  width: 80%;
  margin-top: 1rem;
  gap: 1rem;

  @media (min-width: 768px) {
    width: 50%;
  }

  @media (min-width: 1200px) {
    width: 30%;
  }
`;
